interface LoadingSkeletonProps {
	skeletonCount?: number;
}

export const LoadingSkeleton = ({
	skeletonCount = 1,
}: LoadingSkeletonProps) => {
	return (
		<>
			{Array.from({ length: skeletonCount }).map((_, index) => (
				<div
					// biome-ignore lint/suspicious/noArrayIndexKey: This is a static skeleton list where order doesn't change
					key={`skeleton-item-${index}`}
					className="bg-white px-[15px] pt-[25px] pb-[30px]  animate-pulse"
				>
					<div className="flex flex-col gap-2.5 py-[15px] pl-[15px] pr-0">
						<div className="flex items-center justify-between">
							{/* Title skeleton */}
							<div className="h-7 bg-gray-200 rounded w-3/4" />
							{/* Global icon skeleton */}
							<div className="w-6 h-6 bg-gray-200 rounded" />
						</div>

						<div className=" pl-[15px]">
							{/* Infora answer label skeleton */}
							<div className="h-6 bg-gray-200 rounded w-28 mb-2" />

							{/* Answer text skeleton - multiple lines */}
							<div className="space-y-2">
								<div className="h-4 bg-gray-200 rounded w-full" />
								<div className="h-4 bg-gray-200 rounded w-11/12" />
								<div className="h-4 bg-gray-200 rounded w-4/5" />
							</div>

							<div className="flex items-center justify-between mt-4">
								<div className="flex items-center gap-6">
									{/* Like button skeleton */}
									<div className="flex items-center gap-1">
										<div className="w-5 h-5 bg-gray-200 rounded" />
										<div className="w-8 h-4 bg-gray-200 rounded" />
									</div>

									{/* Comment button skeleton */}
									<div className="flex items-center gap-1">
										<div className="w-5 h-5 bg-gray-200 rounded" />
										<div className="w-8 h-4 bg-gray-200 rounded" />
									</div>

									{/* Send button skeleton */}
									<div className="w-5 h-5 bg-gray-200 rounded" />
								</div>

								{/* Ask More button skeleton */}
								<div className="w-20 h-8 bg-gray-200 rounded-full mr-10" />
							</div>
						</div>
					</div>
				</div>
			))}
		</>
	);
};
